import type { GroupAPIInterface } from './api-switcher'
import { client } from './client'
import { responseDataConverter, apiUserToUser } from './converters'

export const GroupAPI: GroupAPIInterface = {
  listGroups: (signal) => responseDataConverter(
    client.GET('/groups', { signal }),
    (groups) => groups.map(group => ({
      id: group.id,
      name: group.name,
      icon: group.icon || '',
      users: (group.users || []).map(apiUserToUser)
    }))
  ),

  getGroup: (group_id, signal) => responseDataConverter(
    client.GET('/group/{GroupId}', {
      params: { path: { GroupId: group_id } },
      signal
    }),
    (group) => ({
      id: group.id,
      name: group.name,
      icon: group.icon || '',
      users: (group.users || []).map(apiUserToUser)
    })
  ),

  createGroup: (name, icon, user_ids) => responseDataConverter(
    client.POST('/groups', {
      body: { name, icon, user_ids }
    }),
    (group) => ({
      id: group.id,
      name: group.name,
      icon: group.icon || '',
      users: (group.users || []).map(apiUserToUser)
    })
  ),

  updateGroup: (group_id: string, name: string, icon: string) => responseDataConverter(
    client.PATCH('/group/{GroupId}', {
      params: { path: { GroupId: group_id } },
      body: { name, icon }
    }),
    (group) => ({
      id: group.id,
      name: group.name,
      icon: group.icon || '',
      users: (group.users || []).map(apiUserToUser)
    })
  ),

  deleteGroup: (group_id) =>
    client.DELETE('/group/{GroupId}', {
      params: { path: { GroupId: group_id } }
    }).then(({ error, response }) =>
      error
        ? { error: { code: error.code || 0, message: error.message || 'Unknown error' }, response }
        : { response }
    ),

  appendUsersToGroup: (group_id, user_ids) =>
    client.POST('/group/{GroupId}/users', {
      params: { path: { GroupId: group_id } },
      body: { user_ids }
    }).then(({ error, response }) =>
      error
        ? { error: { code: error.code || 0, message: error.message || 'Unknown error' }, response }
        : { response }
    ),

  removeUsersFromGroup: (group_id, user_ids) =>
    client.DELETE('/group/{GroupId}/users', {
      params: { path: { GroupId: group_id } },
      body: { user_ids }
    }).then(({ error, response }) =>
      error
        ? { error: { code: error.code || 0, message: error.message || 'Unknown error' }, response }
        : { response }
    )
}